(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["yg-anchor-item"] && !Shopify.designMode) return;
  try {
    class YGAnchorItem extends HTMLElement {
      #observedSection = null;
      static observer = null;
      static sectionToItem = new Map();
      static isScroll = false;

      constructor() {
        super();
        this.itemClick = this.itemClick.bind(this);
        this.sections = null;
      }

      connectedCallback() {
        this.sections = document.querySelectorAll('#site-main .shopify-section');
        this.addEventListener('click', this.itemClick);

        const sectionNumber = Number(this.getAttribute('data-section-number') || 0);
        if (!this.sections?.length || !Number.isFinite(sectionNumber) || sectionNumber <= 0) return;

        const section = this.sections[sectionNumber - 1];
        if (!section) return;

        this.#observedSection = section;
        YGAnchorItem.#ensureObserver();
        YGAnchorItem.sectionToItem.set(section, this);
        YGAnchorItem.observer.observe(section);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.itemClick);

        if (this.#observedSection && YGAnchorItem.observer) {
          YGAnchorItem.sectionToItem.delete(this.#observedSection);
          YGAnchorItem.observer.unobserve(this.#observedSection);
        }
      }

      static #ensureObserver() {
        if (YGAnchorItem.observer) return;

        YGAnchorItem.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              const item = YGAnchorItem.sectionToItem.get(entry.target);
              if (!YGAnchorItem.isScroll) {
                item && item.setActiveFromObserver();
              }
            });
          },
          {
            root: null,
            threshold: 0.01,
            rootMargin: '-20% 0px -70% 0px',
          }
        );
      }

      setActiveFromObserver() {
        let id = this.getAttribute('data-id');
        let $anchorList;
        if (id) {
          $anchorList = this.parentElement
            ? Array.from(document.querySelectorAll(`yg-anchor-item[data-id="${id}"]`))
            : [];
        } else {
          $anchorList = this.parentElement
            ? Array.from(this.parentElement.querySelectorAll('yg-anchor-item'))
            : [];
        }

        $anchorList.forEach((el, index) => {
          el.classList.toggle('active', el.getAttribute('data-section-number') === this.getAttribute('data-section-number'));

          if (el === this) {
            this.labelClick(index);
          }
        });

        document.dispatchEvent(new CustomEvent('YG:anchor-change', {
          bubbles: true,
        }));
      }

      labelClick(index) {
        // 添加新的活动状态
        const parent = this.parentElement;
        if (parent && this.isScrollable(parent)) {
          const containerRect = parent.getBoundingClientRect();
          const targetRect = this.getBoundingClientRect();
          const scrollLeft = targetRect.left - containerRect.left + parent.scrollLeft - 260;

          parent.scrollTo({
            left: scrollLeft,
            behavior: 'smooth',
          });
        }
      }

      isScrollable(el) {
        if (!el) return false;

        const style = window.getComputedStyle(el);
        const overflowY = style.overflowY;
        const overflowX = style.overflowX;

        const canScrollVertically =
          (overflowY === 'scroll' || overflowY === 'auto') && el.scrollHeight > el.clientHeight;
        const canScrollHorizontally =
          (overflowX === 'scroll' || overflowX === 'auto') && el.scrollWidth > el.clientWidth;

        return canScrollVertically || canScrollHorizontally;
      }

      itemClick() {
        const sectionNumber = this.getAttribute('data-section-number');
        YGAnchorItem.isScroll = true;
        this.setActiveFromObserver();
        if (sectionNumber == 0) {
          window.scrollTo({
            top: 0,
            behavior: 'smooth',
          });
        } else {
          const section = this.sections[sectionNumber - 1];
          if (!section) return;
          const offsetTop = section.getBoundingClientRect().top + window.pageYOffset - 100;
          window.scrollTo({ top: offsetTop, behavior: 'smooth' });
        }

        setTimeout(() => {
          YGAnchorItem.isScroll = false;
        }, 600);
      }
    }
    if (!window.customElements.get('yg-anchor-item')) {
      window.customElements.define('yg-anchor-item', YGAnchorItem);
    }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-collapse-button"] && !Shopify.designMode) return;
  try {
    class YGCollapseButton extends HTMLElement {
    #sectionEl;
    constructor() {
        super()
        this.itemClick = this.itemClick.bind(this)
    }

    get $sectionEl() {
      // if (this.#sectionEl) return this.#sectionEl

      this.#sectionEl = {
        'targetEl': document.querySelector(`.${this.getAttribute('data-target-class')}`),
        'buttonLabel': this.querySelector('.yg-link-label')
      }

      return this.#sectionEl
    }
    connectedCallback() {
        if (!this.$sectionEl['targetEl']) return
        this.init()
        this.addEventListener('click', this.itemClick);
        this.$sectionEl['targetEl'].addEventListener('click', ()=>{this.init()})
    }
    disconnectedCallback() {
        this.removeEventListener('click', this.itemClick);
    }

    init() {
      const target = this.$sectionEl['targetEl'];

      if (!target.classList.contains('yg-collapse-target-el')) {
        target.classList.add('yg-collapse-target-el');
      }

      if (target.hasAttribute('open')) {
        target.style.height = 'auto';
      } else {
        target.style.height = '0px';
      }
    }

    openSection() {
      let target = this.$sectionEl['targetEl'];
      let buttonLabel = this.$sectionEl['buttonLabel'];

      // 先把高度设为当前像素值，再过渡到内容高度
      target.style.height = target.offsetHeight + 'px';
      
      // 强制浏览器重新计算一次布局，确保过渡生效
      target.offsetHeight;

      const endHeight = target.scrollHeight;
      target.style.height = endHeight + 'px';
      target.setAttribute('open', '');
      this.setAttribute('open', '');
      buttonLabel.innerText = this.getAttribute("data-less-label")

      const onTransitionEnd = (event) => {
        if (event.propertyName !== 'height') return;
        target.style.height = 'auto'; // 过渡结束后改为 auto，后续内容高度变化自动适应
        target.removeEventListener('transitionend', onTransitionEnd);
      };

      target.addEventListener('transitionend', onTransitionEnd);
    }

    closeSection() {
      const target = this.$sectionEl['targetEl'];
      const buttonLabel = this.$sectionEl['buttonLabel'];

      // 防止重复关闭
      if (!target.hasAttribute('open')) return;

      this.removeAttribute('open');
      buttonLabel.innerText = this.getAttribute("data-more-label")

      // 从 auto 变成具体高度，再过渡到 0
      if (getComputedStyle(target).height === 'auto') {
        target.style.height = target.scrollHeight + 'px';
      } else if (!target.style.height || target.style.height === '0px') {
        target.removeAttribute('open');
        target.style.height = '0px';
        return;
      }

      // 强制重新计算
      target.offsetHeight;

      target.style.height = '0px';
      target.removeAttribute('open');
      this.removeAttribute('open');
      buttonLabel.innerText = this.getAttribute("data-more-label")
    }

    itemClick() {
      const target = this.$sectionEl['targetEl'];
      if (target.hasAttribute('open')) {
        this.closeSection();
      } else {
        this.openSection();
      }
    }
  }
  if (!window.customElements.get('yg-collapse-button')) {
    window.customElements.define('yg-collapse-button', YGCollapseButton)
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-dropdown"] && !Shopify.designMode) return;
  try {
    class YGDropdown extends YGUtils {
      #dropdownGroup;
      #transitionCleanup;
      #resizeObserver;
      static #groupRegistry = new Map();

      constructor() {
          super()
          this.itemClick = this.itemClick.bind(this);
          this.handleResize = this.handleResize.bind(this);
          this.debouncedResize = this.debounce(this.handleResize, 100);
      }

      #manageGroupRegistry(action) {
        const groupID = this.dataset.group
        if (!groupID) return action === 'get' ? null : undefined

        switch (action) {
          case 'add':
            if (!YGDropdown.#groupRegistry.has(groupID)) {
              YGDropdown.#groupRegistry.set(groupID, new Set())
            }
            YGDropdown.#groupRegistry.get(groupID).add(this)
            break
          case 'remove':
            if (YGDropdown.#groupRegistry.has(groupID)) {
              YGDropdown.#groupRegistry.get(groupID).delete(this)
            }
            break
          case 'get':
            const groupDropdowns = YGDropdown.#groupRegistry.get(groupID)
            this.#dropdownGroup = groupDropdowns ? Array.from(groupDropdowns) : null
            return this.#dropdownGroup
        }
      }

      get dropdownGroup() {
        if (this.#dropdownGroup) return this.#dropdownGroup
        return this.#manageGroupRegistry('get')
      }

      get sectionsEl() {
        if (this._sectionsEl) return this._sectionsEl

        this._sectionsEl = {
          titleContainer: this.querySelector('.yg-dropdown-title-container'),
          contentContainer: this.querySelector('.yg-dropdown-content-container'),
          content: this.querySelector('.yg-dropdown-content')
        }

        return this._sectionsEl
      }

      connectedCallback() {
          this.#manageGroupRegistry('add')

          setTimeout(() => {
            this.initDropdownState()
          }, 60);
          if (this.sectionsEl.titleContainer) {
            this.sectionsEl.titleContainer.addEventListener('click', this.itemClick);
          }
          window.addEventListener('resize', this.debouncedResize);
          this.observeContentResize();
          this.setContentContainerHeight({ immediate: true });
      }

      disconnectedCallback() {
          this.#manageGroupRegistry('remove')

          if (this.sectionsEl.titleContainer) {
            this.sectionsEl.titleContainer.removeEventListener('click', this.itemClick);
          }
          window.removeEventListener('resize', this.debouncedResize);
          if (this.#resizeObserver) {
            this.#resizeObserver.disconnect();
            this.#resizeObserver = null;
          }
          this.clearTransitionCleanup();
      }

      observeContentResize() {
        const content = this.sectionsEl.content
        if (!content || typeof ResizeObserver === 'undefined') return

        if (this.#resizeObserver) {
          this.#resizeObserver.disconnect();
        }

        this.#resizeObserver = new ResizeObserver(() => {
          const contentContainer = this.sectionsEl.contentContainer
          if (!contentContainer || !this.hasAttribute('open')) return

          if (contentContainer.style.height && contentContainer.style.height !== 'auto') {
            contentContainer.style.height = `${content.scrollHeight}px`
          }
        });

        this.#resizeObserver.observe(content)
      }

      clearTransitionCleanup() {
        if (typeof this.#transitionCleanup === 'function') {
          this.#transitionCleanup();
        }
        this.#transitionCleanup = null;
      }

      registerTransitionCleanup(callback) {
        const contentContainer = this.sectionsEl.contentContainer
        if (!contentContainer) return

        this.clearTransitionCleanup()

        const handleTransitionEnd = (event) => {
          if (event.target !== contentContainer || event.propertyName !== 'height') return
          callback?.()
          this.clearTransitionCleanup()
        }

        contentContainer.addEventListener('transitionend', handleTransitionEnd)
        this.#transitionCleanup = () => {
          contentContainer.removeEventListener('transitionend', handleTransitionEnd)
        }
      }

      initDropdownState() {
        const group = this.dropdownGroup

        if (!group || !Array.isArray(group) || group.length === 0) {
          this.setContentContainerHeight({ immediate: true })
          return
        }

        if (group[0] !== this) return

        const openedDropdown = group.find((dropdown) => dropdown.hasAttribute('open'))
        const activeDropdown = openedDropdown || group[0]

        group.forEach((dropdown) => {
          if (dropdown === activeDropdown) {
            dropdown.openDropdown({ skipGroup: true, immediate: true, shouldDispatch: true })
          } else {
            dropdown.closeDropdown({ immediate: true, shouldDispatch: true })
          }
        })
      }

      itemClick() {
          this.setContentContainerHeight();
          let group = this.dropdownGroup;
          if (group && Array.isArray(group) && this.hasAttribute('open')) {
            if (!this.hasAttribute('data-accordion') && group.length > 1) {
              this.closeDropdown();
            }
            return;
          }

          this.hasAttribute('open')?this.closeDropdown():this.openDropdown();
      }

      handleResize() {
        this.setContentContainerHeight({ immediate: true });
      }

      setContentContainerHeight({ immediate = false } = {}) {
        const contentContainer = this.sectionsEl.contentContainer
        const content = this.sectionsEl.content
        if (!contentContainer || !content) return

        if (!this.hasAttribute('open')) {
          contentContainer.style.height = '0px'
          return
        }

        if (immediate) {
          contentContainer.style.height = 'auto'
          return
        }

        if (contentContainer.style.height !== 'auto') {
          contentContainer.style.height = `${content.scrollHeight}px`
        }
      }

      openDropdown({ skipGroup = false, immediate = false, shouldDispatch = true } = {}){
        const contentContainer = this.sectionsEl.contentContainer
        const content = this.sectionsEl.content
        if (!contentContainer || !content) return

        let group = this.dropdownGroup;
        if (!skipGroup && group && Array.isArray(group)) {
            group.forEach(dropdown => {
                if (dropdown !== this) {
                    dropdown.closeDropdown({ shouldDispatch: false });
                }
            });
        }

        this.setAttribute('open', '');

        if (immediate) {
          contentContainer.style.height = 'auto'
        } else {
          this.clearTransitionCleanup()
          const startHeight = contentContainer.style.height === 'auto' ? content.scrollHeight : contentContainer.offsetHeight
          contentContainer.style.height = `${startHeight}px`
          contentContainer.offsetHeight
          contentContainer.style.height = `${content.scrollHeight}px`

          this.registerTransitionCleanup(() => {
            if (this.hasAttribute('open')) {
              contentContainer.style.height = 'auto'
            }
          })
        }

        if (shouldDispatch) {
          document.dispatchEvent(new CustomEvent('YG:dropdown-open', {
            bubbles: true,
            composed: true,
            detail: {
              id: this.getAttribute('data-id')
            }
          }));
        }
      }

      closeDropdown({ immediate = false, shouldDispatch = true } = {}){
        const contentContainer = this.sectionsEl.contentContainer
        const content = this.sectionsEl.content
        if (!contentContainer || !content) return
        if (!this.hasAttribute('open') && !immediate) return

        this.clearTransitionCleanup()

        if (immediate) {
          this.removeAttribute('open');
          contentContainer.style.height = '0px'
          return
        }

        const currentHeight = contentContainer.style.height === 'auto' ? content.scrollHeight : contentContainer.offsetHeight
        contentContainer.style.height = `${currentHeight}px`

        contentContainer.offsetHeight
        this.removeAttribute('open');
        contentContainer.style.height = '0px'

        if (shouldDispatch) {
          document.dispatchEvent(new CustomEvent('YG:dropdown-close', {
            bubbles: true,
            composed: true,
            detail: {
              id: this.getAttribute('data-id')
            }
          }));
        }
      }
  }
  if (!window.customElements.get('yg-dropdown')) {
      window.customElements.define('yg-dropdown',YGDropdown)
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-image"] && !Shopify.designMode) return;
  try {
    class YGImage extends YGImageLazyLoader {
    constructor() {
      super();
    }
    connectedCallback() {
      this.loaderImg();
    }
    get images() {
      return this.querySelectorAll('img[data-src]');
    }

    loaderImg() {
      // 这里放置自定义逻辑
      this.images.forEach((img) => {
        // 安全检查，确保 YGUtils 已加载
        if (this.getLazyLoader) {
          this.getLazyLoader().observe(img);
        } else {
          console.warn('YGUtils 未加载，使用备用图片加载方式');
          // 备用方案：直接设置图片源
          if (img.getAttribute('data-src')) {
            img.src = img.getAttribute('data-src');
            img.removeAttribute('data-src');
          }
        }
      });
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    if (!window.customElements.get('yg-image')) {
      window.customElements.define('yg-image', YGImage);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-open-popup"] && !Shopify.designMode) return;
  try {
    class YGOpenPopup extends HTMLElement {
    constructor() {
      super();
      this.handleActivate = this.handleActivate.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);
    }

    getDirectPopupTemplate() {
      return Array.from(this.children).find((child) => child.matches('template, .yg-popup-template')) || null;
    }

    connectedCallback() {
      this.sectionsEl = {
        popupTemplate: this.getDirectPopupTemplate(),
      };

      if (!this.hasAttribute('role')) {
        this.setAttribute('role', 'button');
      }

      if (!this.hasAttribute('tabindex')) {
        this.setAttribute('tabindex', '0');
      }

      this.addEventListener('click', this.handleActivate);
      this.addEventListener('keydown', this.handleKeydown);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleActivate);
      this.removeEventListener('keydown', this.handleKeydown);
    }

    getPopupTemplate() {
      if (this.sectionsEl.popupTemplate) {
        return this.sectionsEl.popupTemplate;
      }

      if (!this.dataset.popupId) {
        return null;
      }

      return document.getElementById(`yg-popup-template-${this.dataset.popupId}`);
    }

    handleKeydown(event) {
      if (event.key !== 'Enter' && event.key !== ' ') {
        return;
      }

      event.preventDefault();
      this.handleActivate();
    }

    handleActivate() {
      const popupTemplate = this.getPopupTemplate();

      if (!popupTemplate) {
        console.error('popupTemplate is missing');
        return;
      }

      this.dispatchEvent(
        new CustomEvent('YG:openPopup', {
          bubbles: true,
          detail: {
            popupTemplate,
            popupClass: this.dataset.popupClass,
            closeBtnClass: this.dataset.closeBtnClass,
          },
        })
      );
    }
  }
  if (!window.customElements.get('yg-open-popup')) {
    window.customElements.define('yg-open-popup', YGOpenPopup);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-popup"] && !Shopify.designMode) return;
  try {
    class YGPopupBox extends HTMLElement {
    constructor() {
      super();
      this.closePopup = this.closePopup.bind(this);
      this.openPopup = this.openPopup.bind(this);
    }

    // 优化：缓存并懒加载元素，只查询一次，提高性能和可维护性
    get sectionsEl() {
      if (this._sectionsEl) return this._sectionsEl;

      this._sectionsEl = {
        'close': this.querySelector('.yg-popup-box-close'),
        'content-inner': this.querySelector('.yg-popup-box-content-inner'),
        'body': document.body,
      };
      
      return this._sectionsEl;
    }

    connectedCallback() {
      this.addEventListener('click', this.closePopup);
      document.addEventListener('YG:openPopup', this.openPopup);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.closePopup);
      document.removeEventListener('YG:openPopup', this.openPopup);
    }

    openPopup(e) {
      const { popupTemplate, popupClass, closeBtnClass } = e.detail || {};
      
      if (!popupTemplate) {
        console.error('popupTemplate is missing');
        return;
      }
      // popupTemplate：需要替换的元素
      this.sectionsEl['close'].classList.add(`${closeBtnClass}`)
      this.classList.add(`${popupClass}`)
      this.sectionsEl['content-inner'].innerHTML = popupTemplate.innerHTML;
      this.sectionsEl['body'].style.overflow = 'hidden';
      this.style.display = 'flex';
    }

    closePopup(e) {
      const closeBtn = e.target.closest('.yg-popup-box-close');
      const popupBox = e.target.closest('.yg-popup-box');
      if (closeBtn || (popupBox && e.target === popupBox)) {
        this.style.display = 'none';
        this.sectionsEl['content-inner'].innerHTML = '';
        this.sectionsEl['body'].style.overflow = 'auto';
        this.sectionsEl['close'].className = 'yg-popup-box-close';
        this.className = 'yg-popup-box';
      }
    } 
  }
  if (!window.customElements.get('yg-popup-box')) {
    window.customElements.define('yg-popup-box', YGPopupBox);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-tabs"] && !Shopify.designMode) return;
  try {
    class YGTabsTitle extends YGUtils {
      constructor() {
          super()
      }

      get sectionsEl() {
        if (this._sectionsEl) return this._sectionsEl;

        this._sectionsEl = {
          'title-list': Array.from(this.children),
          'content-list': Array.from(document.querySelector(`yg-tabs-content[data-id='${this.dataset.id}']`)?.children || [])
        };

        return this._sectionsEl;
      }

      connectedCallback() {
        this.initTabs()
        this.addEventListener('click', (e) => {
          let item = e.target.closest('.tab-title');
          if (item) {
            let i = this.sectionsEl['title-list'].indexOf(item);
            this.itemClick(item, i);
          }
        });
      }

      initTabs() {
        this.sectionsEl['title-list']?.forEach((el, i) => {
          if (!el.classList.contains('tab-title')) {
            el.classList.add('tab-title');
          }
          
          if (i == 0) {
            el.classList.add('is-active');
          }
        });
        this.updateStyle(this.sectionsEl['title-list'][0]);

        this.sectionsEl['content-list'].forEach((el, i) => {
          if (!el.classList.contains('tab-content')) {
            el.classList.add('tab-content');
          }

          if (i == 0)  el.classList.add('is-active');
        });
      }

      itemClick(el, i) {
        // 如果已经激活则直接返回
        if (el.classList.contains('is-active')) return;

        this.scrollItemIntoView(el);
        this.toggleClass(el, i)
      }

      scrollItemIntoView(el, options = {}) {
        const scrollContainer = this.closest('.yg-scroll-container');
        if (!scrollContainer || !el) return;

        const { behavior = 'smooth' } = options;
        const containerRect = scrollContainer.getBoundingClientRect();
        const itemRect = el.getBoundingClientRect();
        const currentScrollLeft = scrollContainer.scrollLeft;
        const rawScrollLeft = currentScrollLeft + (itemRect.left - containerRect.left) - ((scrollContainer.clientWidth - itemRect.width) / 2);
        const maxScrollLeft = Math.max(scrollContainer.scrollWidth - scrollContainer.clientWidth, 0);
        const nextScrollLeft = Math.min(Math.max(rawScrollLeft, 0), maxScrollLeft);

        if (typeof scrollContainer.scrollTo === 'function') {
          scrollContainer.scrollTo({
            left: nextScrollLeft,
            behavior
          });
          return;
        }

        scrollContainer.scrollLeft = nextScrollLeft;
      }

      toggleClass(el, i) {
        // 处理标题激活状态
        this.sectionsEl['title-list'].forEach((item) => {
          item.classList.remove('is-active');
        });
        el.classList.add('is-active');
        this.updateStyle(el);

        // 处理内容激活状态
        this.sectionsEl['content-list'].forEach((item) => {
          item.classList.remove('is-active');
        });
        if (this.sectionsEl['content-list'][i])
          this.sectionsEl['content-list'][i].classList.add('is-active');
      }

      updateStyle(el = null) {
        let itemEl = el || this.querySelector('.is-active');

        if (!itemEl) return;
        let left = itemEl.offsetLeft;
        let width = itemEl.offsetWidth;
        this.style.setProperty('--scroll-item-left', `${left}px`);
        this.style.setProperty('--scroll-item-width', `${width}px`);
      }
  }
  if (!window.customElements.get('yg-tabs-title')) {
      window.customElements.define('yg-tabs-title', YGTabsTitle)
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-video"] && !Shopify.designMode) return;
  try {
    class YGVideo extends YGVideoLazyLoader {
    constructor() {
      super();
      this.playVideoClick = this.playVideo.bind(this);
      this.autoplay = this.getAttribute('data-autoplay');
      this.popup = this.getAttribute('data-popup');
      this.loop = this.getAttribute('data-loop');
      this.type = this.getAttribute('data-type');
      this.enablePause = this.getAttribute('data-enable-pause') === 'true';
    }

    get videoContainer() {
      return this.querySelector('.yg-video-iframe-container');
    }

    get image() {
      return this.querySelector('.yg-video-placeholder');
    }

    get template() {
      return this.querySelector('template');
    }

    get videoButton() {
      return this.querySelector('.yg-video-button');
    }

    get playVideoButton() {
      return this.querySelector('.yg-video-button .yg-play');
    }

    get pauseVideoButton() {
      return this.querySelector('.yg-video-button .yg-pause');
    }

    connectedCallback() {
      this.playVideoButton?.addEventListener('click', this.playVideoClick);
      this.pauseVideoButton?.addEventListener('click', ()=>this.pauseVideo());
      if (this.autoplay == 'true' && this.popup == 'false') {
        this.getLazyLoader().observe(this);
      }

      // Idle warmup for HTML5 <video> only (skip iframes) to improve first play without blocking main thread.
      this.scheduleHtml5VideoWarmup();
    }

    playVideo() {
      if (this.popup == 'true') {
        this.dispatchEvent(
          new CustomEvent('YG:openPopup', {
            bubbles: true,
            detail: {
              popupTemplate: this.template,
            },
          })
        );

        return;
      }

      this.image?.classList.add('close');
      this.switcherVideoButtonState("play")
      if (!this.videoContainer) {
        this.appendChild(this.template?.content.cloneNode(true));
      }

      if (this.type == 'video' && this.videoContainer) {
        let videos = this.videoContainer.querySelectorAll('.yg-video-iframe');

        this.videoContainer.classList.remove('close');
        videos.forEach(video => {
          video.play();
          // 监听video进度，当进度到达100%，且不循环时切换按钮
          video.addEventListener('timeupdate', () => {
            if (
              video.duration &&
              video.currentTime >= video.duration &&
              this.loop == 'false'
            ) {
              this.pauseVideo();
              this.switcherVideoButtonState("pause");
            }
          });
        });
      }

      
    }

    pauseVideo() {
      this.image?.classList.remove('close');
      this.switcherVideoButtonState("pause")
      
      if (this.type == 'video' && this.videoContainer) {
        let videos = this.videoContainer.querySelectorAll('.yg-video-iframe');
        if (!this.enablePause) {
          this.videoContainer.classList.add('close');
        }

        videos.forEach(video => {
          video.pause();
          if (!this.enablePause) {
            video.currentTime = 0;
          }
        });
      } else {
        this.videoContainer?.remove();
      }
    }

    switcherVideoButtonState (state = "play") {
      if (state == "pause") {
        if (!this.enablePause) {
          this.videoButton?.classList.remove('hide');
        } else {
          this.playVideoButton?.classList.remove('hide');
          this.pauseVideoButton?.classList.add('hide');
        }
        return;
      }
      if (state == "play") {
        if (!this.enablePause) {
          this.videoButton?.classList.add('hide');
        } else {
          this.playVideoButton?.classList.add('hide');
          this.pauseVideoButton?.classList.remove('hide');
        }
        return;
      }
    }

    scheduleHtml5VideoWarmup() {
      // Run once per element instance
      if (this.__ygHtml5WarmupScheduled) return;
      this.__ygHtml5WarmupScheduled = true;

      // Respect "Save-Data" users
      if (navigator?.connection?.saveData) return;

      const run = () => {
        try {
          const urls = this.getPreferredHtml5VideoUrls();
          urls.forEach((url) => this.warmupHtml5VideoUrl(url));
        } catch (e) {
          // Never break section rendering due to warmup.
        }
      };

      // Schedule work in idle time to avoid competing with main thread.
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(run, { timeout: 3000 });
      } else {
        window.setTimeout(run, 1200);
      }
    }

    getPreferredHtml5VideoUrls() {
      const isMobile = window.matchMedia && window.matchMedia('(max-width: 699px)').matches;

      // Prefer template content (when video is deferred) else DOM.
      const root = this.template?.content || this.videoContainer || this;

      // Only HTML5 <video> sources; explicitly skip iframe videos.
      const urls = [];

      // Prefer <source src> which is what Shopify video_tag usually outputs.
      const sources = root.querySelectorAll?.('video.yg-video-iframe source[src]') || [];
      sources.forEach((sourceEl) => {
        const videoEl = sourceEl.closest('video.yg-video-iframe');
        if (!videoEl) return;
        if (isMobile && videoEl.classList.contains('hide-pc')) return;
        if (!isMobile && videoEl.classList.contains('hide-mobile')) return;
        urls.push(sourceEl.getAttribute('src'));
      });

      // Fallback: <video src="...">
      const videos = root.querySelectorAll?.('video.yg-video-iframe[src]') || [];
      videos.forEach((videoEl) => {
        if (isMobile && videoEl.classList.contains('hide-pc')) return;
        if (!isMobile && videoEl.classList.contains('hide-mobile')) return;
        urls.push(videoEl.getAttribute('src'));
      });

      return [...new Set(urls.filter(Boolean))].filter((u) => !u.startsWith('blob:'));
    }

    warmupHtml5VideoUrl(url) {
      if (!url) return;

      // De-dupe across the whole page
      window.__ygWarmupVideoUrls ||= new Set();
      if (window.__ygWarmupVideoUrls.has(url)) return;
      window.__ygWarmupVideoUrls.add(url);

      // Hint preload (low priority where supported)
      try {
        const link = document.createElement('link');
        link.rel = 'preload';
        link.as = 'video';
        link.href = url;
        link.crossOrigin = 'anonymous';
        // Some Chromium builds support this; safe elsewhere.
        link.fetchPriority = 'low';
        document.head.appendChild(link);
      } catch (e) {}

      // Prime HTTP cache with a small Range request (best-effort). Only for same-origin / Shopify CDN to avoid CORS surprises.
      try {
        const u = new URL(url, window.location.href);
        const isSameOrigin = u.origin === window.location.origin;
        const isShopifyCdn = u.hostname.endsWith('cdn.shopify.com');
        if (!isSameOrigin && !isShopifyCdn) return;

        const controller = new AbortController();
        const timeoutId = window.setTimeout(() => controller.abort(), 4000);

        fetch(u.toString(), {
          method: 'GET',
          mode: 'cors',
          credentials: 'omit',
          cache: 'force-cache',
          headers: {
            Range: 'bytes=0-1048575',
          },
          signal: controller.signal,
        })
          .catch(() => {})
          .finally(() => window.clearTimeout(timeoutId));
      } catch (e) {}
    }

  }
  document.addEventListener('DOMContentLoaded', () => {
    if (!window.customElements.get('yg-video')) {
      window.customElements.define('yg-video', YGVideo);
    }
  });
  } catch(e) { console.error(e); }
})();

})();
